import {
    getLegs,
    addLeg,
    deleteLeg,
    cancelLeg,
    unCancelLeg,
    noShowLeg,
    unNoShowLeg,
    acceptPendingLegs,
    rejectPendingLegs,
    getLegsTotals,
    legAssignOrChangeData,
    editTrip,
    deleteTrip,
    cancelTrip,
    unCancelTrip,
    refreshAllData,
    recalculateTripRevenue,
    getSingleTrip,
    repeatWeekly,
    editLegList,
    uploadLegCsv,
    creteLegNote,
    editLegNote,
    deleteLegNote,
} from "./legs.action";

export {legsReducer} from "./legs.reducer";
export {watchLegs} from "./legs.saga";

export const legsActions = {
    /** Legs */
    getLegs,
    addLeg,
    editLegList,
    deleteLeg,
    cancelLeg,
    unCancelLeg,
    noShowLeg,
    unNoShowLeg,
    refreshAllData,
    acceptPendingLegs,
    rejectPendingLegs,
    /** Note Leg */
    creteLegNote,
    editLegNote,
    deleteLegNote,
    /** End */

    legAssignOrChangeData,
    getLegsTotals,
    /** Trip */
    getSingleTrip,
    repeatWeekly,
    editTrip,
    deleteTrip,
    cancelTrip,
    unCancelTrip,
    recalculateTripRevenue,

    uploadLegCsv
};
